// Pagination constants

export const PAGINATION = {
  CONTACTS: 20,
  APPLICATION: 20,
};
